import { getClosedOrderClientRefusalReason } from "../../../../../../../utils/clientRefusalReason";

import type { Order, Language } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (
	item: Order.Model,
	language: Language,
	t: TFunction,
): string => {
	const comment = item?.closedOrderComments?.[0];

	return getClosedOrderClientRefusalReason(
		comment?.status === "hide_by_transfer"
			? item?.additionalFields?.transfer?.lastReceivedOrder
					?.closedOrderComments?.[0]
			: comment,
		language,
		t,
	);
};

export default cellProcessing;
